import React from "react";
import { Grid, Container } from "semantic-ui-react";
import styles from "./Page404.module.scss";
import { Body1 } from "../../components/value-cssmodules/TextComponent";
import MainButton from "../../components/Button/MainButton";
import LightButton from "../../components/Button/LightButton";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const Page404 = () => {
  return (
    <Grid className={styles.self}>
      <Container>
        <img
          src="/icons/404nums.svg"
          className={styles.numbers}
          alt="404 numbers"
        />
        <img
          src="/icons/sewingButton.svg"
          className={styles.errorImg}
          alt="Spinning sewing Button"
        />

        <Body1 className={styles.erorrParagraph}>
          <FormattedMessage
            id="page404.message"
            defaultMessage="Oops. We couldn't find that page. Go back to the previous page or return home."
          />
        </Body1>
        <Container className={styles.buttonsBlock}>
          <LightButton className={styles.errorPageLightButton}>
            <FormattedMessage
              id="page404.backButton"
              defaultMessage="Go back to the previous page"
            />
          </LightButton>
          <Link to="/">
            <MainButton className={styles.errorPageMainButton}>
              <FormattedMessage
                id="page404.homeButton"
                defaultMessage="Return to homepage"
              />
            </MainButton>
          </Link>
        </Container>
      </Container>
    </Grid>
  );
};

export default Page404;
